import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Button, Card, CardContent, PlusCircleIcon } from '@metarouter-private/mr-mui';

export default function EmptyState({ canWrite, onCreateClick }) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2} alignItems="center" py={4}>
          <Typography variant="body1" color="text.secondary">
            No webhook configured for this organization.
          </Typography>
          {canWrite && (
            <Button variant="contained" startIcon={<PlusCircleIcon />} onClick={onCreateClick}>
              Create Webhook Configuration
            </Button>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}

EmptyState.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  onCreateClick: PropTypes.func.isRequired,
};
